import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {Calendar} from "@fullcalendar/core";
import interaction from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import huLocale from '@fullcalendar/core/locales/hu';
import enLocale from '@fullcalendar/core/locales/en-gb';
import skLocale from '@fullcalendar/core/locales/sk';
import deLocale from '@fullcalendar/core/locales/de';
import {TranslateService} from "@ngx-translate/core";
import {Utilities} from "../../../utils/utilities";

@Component({
    selector: 'app-mb-calendar',
    templateUrl: './mb-calendar.component.html',
    styleUrls: ['./mb-calendar.component.scss']
})
export class MbCalendarComponent implements OnInit, OnChanges {

    @Input() events: any[];
    @Input() dateClick: any;
    @Input() eventClick: any;
    @Input() next: any;
    @Input() defaultDate: Date;
    @Input() businessHours = new MbCalendarBusinessHours();
    @Output() dayRenderEmit:EventEmitter<any> = new EventEmitter();

    @ViewChild('calendar') calendarElement: ElementRef<HTMLElement>;
    public calendar: Calendar;

    public startDate: string;


    constructor(private translateService: TranslateService) {
    }

    ngOnInit() {
        this.startDate = Utilities.dateToBackendString(Utilities.minusDays(new Date(), 7));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (Object.keys(changes).includes('events')) {
            this.events = changes.events.currentValue;
            if(this.calendar){
               this.calendar.removeAllEvents();
               this.events.forEach(event =>{
                   this.calendar.addEvent(event);
               })
            }else {
                this.createCalendar(Utilities.dateToBackendString(this.defaultDate));
            }
        }
    }

    fallbackNext(event) {
        this.dayRenderEmit.emit(event.date);
    }

    createCalendar(defaultDate:string) {
        if (this.calendarElement != undefined) {
            this.calendarElement.nativeElement.innerHTML = '';
            this.calendar = new Calendar(this.calendarElement.nativeElement, {
                defaultDate:defaultDate,
                plugins: [interaction, dayGridPlugin, timeGridPlugin],
                locales: [huLocale, enLocale, skLocale, deLocale],
                locale: (this.translateService.currentLang == 'en' ? 'en-gb':this.translateService.currentLang),
                validRange: {
                    start: this.startDate
                },
                minTime: '08:00:00',
                header: {
                    left: 'title',
                    center: 'timeGridWeek,timeGridDay',
                    right: 'prev,next,today'
                },
                slotLabelFormat: {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                },
                eventTimeFormat: { // like '14:30:00'
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                },
                // businessHours: this.businessHours,
                dateClick: this.dateClick.bind(this),
                dayRender: this.fallbackNext.bind(this),
                selectable: true,
                nowIndicator: true,
                droppable: false,
                defaultView: 'timeGridDay',
                editable: false,
                events: this.events,
                views: {
                    month: {
                        titleFormat: {month: 'long', year: 'numeric'}
                    },
                    agendaWeek: {
                        titleFormat: {month: 'long', year: 'numeric', day: 'numeric'}
                    },
                    agendaDay: {
                        titleFormat: {month: 'short', year: 'numeric', day: 'numeric', hour12: false}
                    }
                },
                eventClick: this.eventClick.bind(this),
                eventRender: (info) => {
                    info.el.innerHTML = info.el.innerHTML.replace('ICON', '<i class="fas fa-comment"></i>');
                    info.el.innerHTML = info.el.innerHTML.replace('BOOKMARK', '<i class="fas fa-bookmark"></i>');
                }
            });
            this.calendar.render();
        }
    }
}

export class MbCalendarBusinessHours {
    daysOfWeek: number[];
    startTime: string;
    endTime: string;

    constructor(daysOfWeek?: number[], startTime?: string, endTime?: string) {
        this.daysOfWeek = (daysOfWeek ? daysOfWeek : [0, 1, 2, 3, 4, 5, 6]);
        this.startTime = (startTime ? startTime : '06:00');
        this.endTime = (endTime ? endTime : '20:00');
    }
}
